module.exports = __webpack_public_path__ + "static/about-caitlin-e1fd9f1ff00fb537270ad0dc8a1e2bf0.jpg";